module.exports = __webpack_public_path__ + "static/img/IMG_00003.d3be21d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf1/IMG_00003.png
// module id = blha
// module chunks = 7